import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Typography } from 'antd';
import Tag from 'components/Tag';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import NotAvailable from 'components/NotAvailable';

const { Title, Text } = Typography;

export const CompanyRow = ({ children, className, ...rest }) => {
  return (
    <Row
      gutter={16}
      className={classnames(className, 'kyb-company-summary-row')}
      {...rest}
    >
      {children}
    </Row>
  );
};

export const CompanyCard = ({ children, className, ...rest }) => (
  <div className={classnames(className, 'kyb-company-summary-card')} {...rest}>
    {children}
  </div>
);

export const CompanyH5 = ({ children, className, level }) => (
  <Title leve={level} className={classnames(className, 'typescale-subtitle-1')}>
    {children}
  </Title>
);

export const CompanySubtitle1 = ({ children, className, level }) => (
  <Title leve={level} className={classnames(className, 'typescale-subtitle-1')}>
    {children}
  </Title>
);

export const CompanySubtitle2 = ({ children, className, level }) => (
  <Title level={level} className={classnames(className, 'typescale-subtitle-2')}>
    {children}
  </Title>
);

export const CompanyBody1 = ({ children }) => (
  <Text className="typescale-body-1">
    {children && children !== '-' ? children : <NotAvailable />}
  </Text>
);

export const CompanyLink = ({ children, to }) => (
  <Link to={to} className="kyb-company-summary-link">
    {children}
  </Link>
);

export const CompanyTag = ({ children, className, ...rest }) => {
  if (rest.empty) {
    return <div className="kyb-company-summary-tag kyb-company-summary-tag-empty" />;
  }
  return (
    <Tag className={classnames(className, 'kyb-company-summary-tag')} {...rest}>
      {children}
    </Tag>
  );
};

const propTypesSubtitle = {
  className: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
};
const propTypesLink = {
  to: PropTypes.string.isRequired,
};
const basicPropTypesTag = {
  className: PropTypes.string.isRequired,
};
const propTypesTag = basicPropTypesTag;
const propTypesRow = basicPropTypesTag;
const propTypesCard = basicPropTypesTag;

CompanyRow.propTypes = propTypesRow;
CompanyTag.propTypes = propTypesTag;
CompanyCard.propTypes = propTypesCard;
CompanyLink.propTypes = propTypesLink;
CompanyH5.propTypes = propTypesSubtitle;
CompanySubtitle1.propTypes = propTypesSubtitle;
CompanySubtitle2.propTypes = propTypesSubtitle;
